<template>
  <div class="serial-code-dialog">
    <el-dialog custom-class="with-title x-large" :title="title" :visible.sync="visible" :before-close="beforeClose">
      <serial-code-table
        v-if="!serialCodeIsCreated"
        :isChangeWithoutSubmit.sync="isChangeWithoutSubmit"
        :onChangeSortBy="onChangeSerialCodeListSortBy"
        :onChange="onChangeSerialCodeList"
        :onClickSerialCodeCreate="onClickSerialCodeCreate"
        ref="serialCodeTable"
      ></serial-code-table>
      <serial-code-create
        v-if="serialCodeIsCreated"
        :isChangeWithoutSubmit.sync="isChangeWithoutSubmit"
      ></serial-code-create>
    </el-dialog>
  </div>
</template>

<style lang="scss">
@use '@/client/assets/scss/variables.scss' as *;

.serial-code-dialog {
  .serial-code-create {
    padding-right: $spacing-unit * 2;
  }
}
</style>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import SerialCodeCreate from '@/client/features/twitter_applicant/serial_code_create'
import SerialCodeTable from '@/client/features/twitter_applicant/serial_code_table'
import { TrackingService } from '@/client/services'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterSerialCodeDialogStore } from '@/client/store/useTwitterSerialCodeDialogStore'

export default defineComponent({
  components: {
    SerialCodeTable,
    SerialCodeCreate
  },
  data() {
    return {
      visible: false,
      title: 'シリアルコードの管理',
      messageQueueId: 0,
      queueCreate: false,
      queuesTargets: false,
      queuesTargetsStatus: '',
      messageTemplates: [],
      isChangeWithoutSubmit: false,
      serialCodeCreate: false
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroup: state => state.currentGroup
    }),
    ...mapState(useTwitterSerialCodeDialogStore, {
      serialCodeListParams: state => state.serialCode.params,
      serialCodeIsCreated: state => state.serialCode.isCreated
    })
  },
  watch: {
    // シリアルコードパラメタを変更する際、シリアルコード一覧を取得
    serialCodeListParams() {
      this.fetchSerialCodeList()
    }
  },
  methods: {
    ...mapActions(useTwitterSerialCodeDialogStore, [
      'reset',
      'setPrizeId',
      'setCampaignId',
      'fetchSerialCodeList',
      'setSerialCodeListParams',
      'setSerialCodeIsCreated'
    ]),

    /**
     * シリアルコード一覧ソートを変更イベント
     * @param {string} sortBy ソート
     */
    onChangeSerialCodeListSortBy(sortBy: string) {
      if (this.serialCodeListParams.sortBy === sortBy) {
        return
      }
      this.setSerialCodeListParams({ sortBy })
    },

    /**
     * シリアルコード一覧
     */
    onChangeSerialCodeList() {
      this.fetchSerialCodeList()
    },

    /**
     * シリアルコード追加ボタンのクリックイベント
     */
    onClickSerialCodeCreate() {
      this.setSerialCodeIsCreated(true)
      this.serialCodeCreate = true
    },

    /**
     * ダイアログを開く
     * @param {number} キャンペーンID
     */
    open(prizeId: number, campaignId: number) {
      this.visible = true
      this.setPrizeId(prizeId)
      this.setCampaignId(campaignId)
      this.fetchSerialCodeList()

      const serialCodeTable = this.$refs.serialCodeTable as { reset: () => void } | undefined
      if (serialCodeTable) {
        serialCodeTable.reset()
      }
    },

    /**
     * ダイアログを閉じる
     */
    close() {
      // 一括のメッセージストアをリセット
      this.serialCodeCreate = false
      this.isChangeWithoutSubmit = false
      this.reset()
    },

    /**
     * ダイアログ閉じるイベント
     */
    beforeClose(done) {
      TrackingService.sendEvent(
        `click:シリアルコードの管理|シルアルコード${this.serialCodeCreate ? '追加' : '管理'}|閉じる`
      )

      if (!this.isChangeWithoutSubmit) {
        this.close()
        return done()
      }

      const confirm = window.confirm('編集内容が保存されていません。ダイアログを閉じてよろしいですか?')

      if (!confirm) {
        return
      }

      this.close()
      done()
    }
  }
})
</script>
